// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dd436752","239":"bd1f3a4d","667":"0c561036"}[chunkId] + ".chunk.js";
};